// Clinic Configuration for Dentist in Powell
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist in Powell",
  clinicId: "dentistinpowellohio",
  clinicUrl: "dentistinpowellohio.com",
  // Contact Information
  phoneNumber: "(614) 659-0018",
  phoneNumberRaw: "+16146590018", // For tel: and sms: links
  email: "dentalcare@dentistinpowellohio.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistinpowellohio&agentId=4ed4708c-7f6e-4079-86d1-afebd734ca6a",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistinpowellohio/voice",

  // Location
  address: "4091 W Powell Rd #1, Powell, OH 43065, United States",
  addressShort: "4091 W Powell Rd #1, Powell, OH 43065",
  city: "Powell",
  hcity: "Powell",
  state: "Ohio",
  stateShortForm: "OH",
  PostalCode: "43065",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/9vhzNoc4TQ9RQSLw5",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2759.4505662457263!2d-83.0961493!3d40.1580489!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8838ede1b73acb19%3A0xca8ed5d32f13cf36!2sDentist%20in%20Powell!5e1!3m2!1sen!2sin!4v1759819852801!5m2!1sen!2sin',
  iframeTitle: "Dentist in Powell",

  //membership
  membership: "https://member.kleer.com/?slug=WD5X",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/DentistinPowell",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/dentist-in-powell?utm_source=practice&utm_medium=email&m=65968",


  // Analytics
  clarityProjectId: "prdd94j7x5",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistinpowellohio",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistinpowellohio",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistinpowellohio",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/DentistinPowell",
    instagram: "https://www.instagram.com/dentistinpowell/",
    twitter: "https://x.com/Dentist__Powell",
    linkedin: "https://www.linkedin.com/company/dentist-in-powell/",
    youtube: "https://www.youtube.com/@DentistinPowell",
  },

  // Open Dental Configuration
  defaultProvNum: 4,
  defaultOpNum: 10,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: "New patient emergency/other",
      label: "New patient emergency/other",
      duration: 30,
      opNum: 8,
      AppointmentTypeNum: 6,
    },
    {
      value: "Existing patient emergency/other",
      label: "Existing patient emergency/other",
      duration: 30,
      opNum: 10, // DEFAULT_OP_NUM
      AppointmentTypeNum: 4,
    },
    {
      value: "Existing patient current treatment Plan",
      label: "Existing patient current treatment Plan",
      duration: 30,
      opNum: 10, // DEFAULT_OP_NUM
      AppointmentTypeNum: 17,
    },
  ],

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:${this.phoneNumberRaw}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  membership,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;

